import { ERegisterOrAuthStatus, ESendValidationCodeStatus } from '../../types/phoneAuth';
export function isPhoneAuthValidateFormSubmitting(state) {
  return state.phoneAuth.registerOrAuth.status === ERegisterOrAuthStatus.Loading || state.phoneAuth.sendValidationCode.status === ESendValidationCodeStatus.Loading || state.phoneAuth.registerOrAuth.status === ERegisterOrAuthStatus.Succeed;
}
export function resendTimeoutSelector(state) {
  return state.phoneAuth.sendValidationCode.secondsToRetry;
}
export function sendValidationCodeStatusSelector(state) {
  return state.phoneAuth.sendValidationCode.status;
}
export function hasRegisterOrAuthErrorSelector(state) {
  var _state$phoneAuth$regi = state.phoneAuth.registerOrAuth,
      status = _state$phoneAuth$regi.status,
      error = _state$phoneAuth$regi.error;
  var _state$phoneAuth$send = state.phoneAuth.sendValidationCode,
      smsStatus = _state$phoneAuth$send.status,
      smsError = _state$phoneAuth$send.error;
  return status === ERegisterOrAuthStatus.Failed && error !== undefined || smsStatus === ESendValidationCodeStatus.Failed && smsError !== undefined;
}
export function registerOrAuthErrorSelector(state) {
  return hasRegisterOrAuthErrorSelector(state) ? state.phoneAuth.registerOrAuth.error || state.phoneAuth.sendValidationCode.error : undefined;
}